import { useInstance } from 'intact-vue-next';
import { useBaseLabel } from '../select/useBaseLabel';
export function useLabel(getField) {
  var instance = useInstance();
  function findLabel(data, value) {
    var _instance$get = instance.get(),
      format = _instance$get.format;
    var labels = [];
    var length = value.length;
    var loop = function loop(data, level) {
      if (level === length) return;
      for (var i = 0; i < data.length; i++) {
        var item = data[i];
        if (getField(item, 'value') === value[level]) {
          labels.push(getField(item, 'label'));
          var children = getField(item, 'children');
          if (children) {
            loop(children, level + 1);
          }
        }
      }
    };
    loop(data, 0);
    return labels.length ? format(labels) : null;
  }
  return useBaseLabel(function () {
    return instance.get('data');
  }, findLabel);
}